import React from "react";

const WarningSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24Z"
        fill="#F6BC2F"
      />
      <path
        d="M24.5556 33.9479C25.7829 33.9479 26.7778 32.953 26.7778 31.7257C26.7778 30.4984 25.7829 29.5035 24.5556 29.5035C23.3283 29.5035 22.3333 30.4984 22.3333 31.7257C22.3333 32.953 23.3283 33.9479 24.5556 33.9479Z"
        fill="#5F6368"
      />
      <path
        d="M22.3333 13.9479H26.7778V27.2812H22.3333V13.9479Z"
        fill="#5F6368"
      />
    </svg>
  );
};

export default WarningSvg;
